export default __webpack_public_path__ + "images/J3.1107168.png";